export default __webpack_public_path__ + "static/media/images/kicad.d072fe70.jpg";